// C:\Users\cornn\source\repos\purehealthnexus\src\pages\ToolsandApps.jsx
import React from 'react';
import '../styles/pages/toolsandapps.css';
import { trackCalculatorClick } from '../firebase/firebaseitemstats'; 

const tools = [
  { id: 1, name: 'Vitamin D Calculator', description: 'Estimate your daily Vitamin D intake based on your lifestyle and health factors.', link: '/vitamin-d-calculator', image: '/assets/images/appsvitamin-d.webp', alt: 'Vitamin D Calculator Icon' },
  { id: 2, name: 'Vitamin B12 Calculator', description: 'Assess your Vitamin B12 intake and identify potential gaps based on your diet and health factors.', link: '/vitamin-b12-calculator', image: '/assets/images/appsvitamin-b12.webp', alt: 'Vitamin B12 Calculator Icon' },
  { id: 3, name: 'Vitamin C Calculator', description: 'Evaluate your Vitamin C intake and ensure you\'re meeting your daily needs for optimal health.', link: '/vitamin-c-calculator', image: '/assets/images/appsvitamin-c.webp', alt: 'Vitamin C Calculator Icon' },
  { id: 4, name: 'Mineral Iron Calculator', description: 'Check your daily Iron intake and ensure you meet your nutritional requirements.', link: '/mineral-iron-calculator', image: '/assets/images/appsiron.webp', alt: 'Iron Calculator Icon' },
  { id: 5, name: 'Mineral Magnesium Calculator', description: 'Assess your Magnesium intake and ensure you meet your daily needs for optimal health.', link: '/mineral-magnesium-calculator', image: '/assets/images/appsmagnesium.webp', alt: 'Magnesium Calculator Icon' },
  { id: 6, name: 'Mineral Calcium Calculator', description: 'Evaluate your Calcium intake and ensure you meet your daily needs for strong bones and overall health.', link: '/mineral-calcium-calculator', image: '/assets/images/appscalcium.webp', alt: 'Calcium Calculator Icon' },
  { id: 7, name: 'Omega-3 Fatty Acid Calculator', description: 'Assess your Omega-3 intake and ensure you meet your daily needs for heart and brain health.', link: '/omega-3-fatty-acid-calculator', image: '/assets/images/appsomega3.webp', alt: 'Omega-3 Calculator Icon' },
  { id: 8, name: 'Vitamin Folate(B9) + B12 Calculator', description: 'Assess your Vitamin Folate and B12 intake to ensure you meet your daily needs for optimal health.', link: '/vitamin-folate-calculator', image: '/assets/images/appsvitamin-folate.webp', alt: 'Vitamin Folate(B9) + B12 Calculator Icon' },
  { id: 9, name: 'Mineral Zinc Calculator', description: 'Evaluate your Zinc intake and ensure you meet your daily needs for immune support and overall health.', link: '/mineral-zinc-calculator', image: '/assets/images/appszinc.webp', alt: 'Zinc Calculator Icon' },
  { id: 10, name: 'Vitamin K Calculator', description: 'Assess your Vitamin K intake and ensure you meet your daily needs for optimal health.', link: '/vitamin-k-calculator', image: '/assets/images/appsvitamin-k.webp', alt: 'Vitamin K Calculator Icon' },
  { id: 11, name: 'Potassium & Sodium Calculator', description: 'Evaluate your Potassium and Sodium intake to ensure you meet your daily needs for optimal health.', link: '/potassium-sodium-calculator', image: '/assets/images/appspotassium.webp', alt: 'Potassium & Sodium Calculator Icon' },
  { id: 12, name: 'Vitamin A (Carotenoid) Calculator', description: 'Vitamin A is essential for vision, immune function, and skin health. Use this calculator to check if you’re getting enough carotenoid-rich Vitamin A from your diet for optimal wellness.', link: '/vitamin-a-carotenoid-calculator', image: '/assets/images/appsvitamin-a.webp', alt: 'Vitamin A (Carotenoid) Calculator Icon' },
  { id: 13, name: 'Vitamin E Calculator', description: 'Vitamin E is a vital antioxidant that protects your cells from damage. Use this calculator to check if you’re getting enough Vitamin E to support healthy skin, immune function, and overall well-being.', link: '/vitamin-e-calculator', image: '/assets/images/appsvitamin-e.webp', alt: 'Vitamin E Calculator Icon' },
  { id: 14, name: 'BMI & Body Fat Calculator', description: 'Calculate your BMI and body fat percentage to assess your overall health.', link: '/bmi-bodyfat-calculator', image: '/assets/images/appsbmi.webp', alt: 'BMI & Body Fat Calculator Icon' },
  { id: 15, name: '1 Rep Max Calculator', description: 'Estimate your one-rep max for strength training exercises.', link: '/one-rep-max-calculator', image: '/assets/images/appsonerepmax.webp', alt: 'One Rep Max Calculator Icon' },
  { id: 16, name: 'Vitamin Biotin (B7) Calculator', subtitle: 'Hair, Skin, Nails', description: 'Assess your Vitamin Biotin intake and its impact on hair, skin, and nails to ensure you meet your daily needs for optimal health.', link: '/vitamin-biotin-calculator', image: '/assets/images/appsvitamin-biotin.webp', alt: 'Vitamin Biotin Calculator Icon – Hair, Skin, Nails' },
];

function ToolsandApps() {
  // Sort tools alphabetically for a consistent UX
  const sortedTools = [...tools].sort((a, b) => a.name.localeCompare(b.name));

  // Track click and navigate
  const handleCalculatorInteraction = async (calculatorName, link) => {
    if (!link) {
      alert('Coming Soon!');
      return;
    }
    try {
      await trackCalculatorClick(calculatorName);
    } catch (error) {
      console.error('Error during calculator click tracking:', error);
    }
    window.location.href = link;
  };

  return (
    <div className="tools-and-apps-page">
      <h1>Health Tools &amp; Wellness Apps</h1>
      <p>Wellness tools, calculators and resources for simple, actionable healthy living.</p>

      <div className="tools-grid">
        {sortedTools.map((tool) => (
          <div className="tool-card" key={tool.id}>
            <div
              className="tool-icon-clickable-area"
              onClick={() => handleCalculatorInteraction(tool.name, tool.link)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  handleCalculatorInteraction(tool.name, tool.link);
                }
              }}
              role="button"
              tabIndex={0}
              aria-label={`Access ${tool.name}`}
              style={{ cursor: 'pointer', display: 'block' }}
            >
              <img src={tool.image} alt={tool.alt} className="tool-icon" loading="lazy" />
            </div>

            <div className="tool-content">
              <h2>{tool.name}</h2>
              {tool.subtitle && (
                <h3 style={{ textAlign: 'center', fontWeight: 'normal' }}>{tool.subtitle}</h3>
              )}
              <p>{tool.description}</p>

              <button
                onClick={() => handleCalculatorInteraction(tool.name, tool.link)}
                className="tool-link"
                aria-label={`${tool.link ? 'Try' : 'Get more info on'} ${tool.name}`}
              >
                {tool.link ? 'Try Now' : 'More Info'}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ToolsandApps;
